module.exports = __webpack_public_path__ + "media/stairs.db6038c7.mp4";